import React, {Component} from 'react';
import Slido from "./Slido";

export default class Chat extends Slido {

    adjustComponentHeight() {
        let height = document.getElementById('video-frame').clientHeight - 16; // 23 - padding
        height = height < this.minHeight ? this.minHeight : height;
        document.getElementById('ChatContainer').style.height=height+'px';

        const newMessageHeight = document.getElementById('new-message').offsetHeight;
        const messageBlock = document.getElementById('message-block');

        messageBlock.style.height=(height-newMessageHeight)+'px';
        messageBlock.scrollTop = messageBlock.scrollHeight;
    }

    render() {
        const { isEnabled, sendBtnText } = this.props

        if( isEnabled == '0' || sendBtnText === '') {
            return null;
        }

        if(!this.timer) {
            this.timer=setInterval(() => {
                this.adjustComponentHeight();
            }, 1000);
        }

        //  height={this.state.height} width={"100%"} className={"resizable-container"}
        return (
            <div id={"ChatContainer"}  style={{transitionProperty: "all", transitionDuration: "1.5s"}} title={"Chat"}>
                <div id="message-block">
                    <div id="chat-messages">
                        <table cellPadding="0" cellSpacing="0">
                            <tbody id="chat-table"></tbody>
                        </table>
                    </div>

                </div>

                <div id="new-message">
                    <textarea id="user-message" onKeyUp={ (event)=>{chat.keyUpFunc(event)}} />

                    <input type="button" id="send-btn" onClick={()=>{chat.send();}} value={sendBtnText}/>
                </div>

            </div>
        )
    }
}
